import {
  getCommcommunityAll,
  getPointLevelThreeListById,
  getPointTypeListPage
} from "@/api/point.js";
export default {
  data() {
    return {
      communityCode: '',
      commcommunityList: [],
      blockList: [],
      pointTypeOptions: []
    }
  },
  methods: {
    commcommunityChange(value) {
      let arr = value && value.split('-')
      if (arr && arr.length) {
        this.form.communityCode = arr[1]
        this.getblockAllByCommunityIdFun(arr[0]);
      }
    },
    // 社区列表
    async getCommcommunityAllFun() {
      const res = await getCommcommunityAll();
      this.commcommunityList = res.data.data;
    },
    // 网格列表
    async getblockAllByCommunityIdFun(id) {
      const res = await getPointLevelThreeListById({
        id: id
      });
      this.blockList = res.data.data;
    },
    // 点位类型
    async getPointTypeListPageFun() {
      const res = await getPointTypeListPage({
        enableStatus: 0,
        page: 1,
        size: 9999
      });
      this.pointTypeOptions = res.data.data.records;
    },
  },
  computed: {
    getPointTypeName() {
      return function (id) {
        let name = "";
        this.pointTypeOptions.forEach(item => {
          if (item.id == id) {
            name = item.typeName;
          }
        });
        return name;
      };
    }
  },
  watch: {
    communityCode: {
      deep: true,
      handler(val) {
        if (!val) this.form.communityCode = ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js